import { render, staticRenderFns } from "./set-order.vue?vue&type=template&id=5940c02b&scoped=true&"
import script from "./set-order.vue?vue&type=script&lang=js&"
export * from "./set-order.vue?vue&type=script&lang=js&"
import style0 from "./set-order.vue?vue&type=style&index=0&id=5940c02b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5940c02b",
  null
  
)

export default component.exports